/* eslint-disable operator-assignment*/
import { IStoreState } from 'store';
import {
  ILineGraphItem,
  EEvaluationUnit,
  ECostFormulaParamTypeLabel,
  EForecastEvaluationTypeLabel,
  ISummaryFormula,
} from 'store/deal-evaluation/types';
import labels from 'constants/labels';
import lineColors from 'components/visuals/multi-line-graph/colors';
import { generateContractPeriodString } from 'lib/helpers/date-range';
import { EDisplayLabel } from 'components/deal-results/product-items';
import { IDealWithEvaluation } from 'store/deal-comparison/types';

export const getLineGraphItems = (state: IStoreState): ILineGraphItem[] => {
  const lineGraphItemsNew: ILineGraphItem[] = [];
  let colorIndex = 0;
  const { dealsWithEvaluation } = state.dealComparison;
  if (!dealsWithEvaluation) {
    return lineGraphItemsNew;
  }
  dealsWithEvaluation.forEach((dealWithEvaluation: IDealWithEvaluation) => {
    lineGraphItemsNew.push({
      label: dealWithEvaluation.deal.name,
      active: true,
      color: lineColors[colorIndex],
      priceSummary: {
        description: generateContractPeriodString(dealWithEvaluation.deal.products),
        base: ((dealWithEvaluation.evaluation?.base as unknown) as ISummaryFormula) || null,
        sales: ((dealWithEvaluation.evaluation?.sales as unknown) as ISummaryFormula) || null,
        netback: ((dealWithEvaluation.evaluation?.netback as unknown) as ISummaryFormula) || null,
        margin: (dealWithEvaluation.evaluation?.margin as unknown) as ISummaryFormula | null,
        marginAtRisk: 0,
        yield: 0,
        costToServe: 0,
        cost_reimbursed: 0,
        cost_freight: 0,
      },
    });
    colorIndex = colorIndex + 1;
  });
  return lineGraphItemsNew;
};

export const getLegendText = (state: IStoreState): string => {
  const { selectedDisplay } = state.dealComparison;
  const { selectedForecastType, selectedCostFormulaType } = state.dealEvaluation;

  return `Deal Comparison, ${EDisplayLabel[selectedDisplay]}, ${EForecastEvaluationTypeLabel[selectedForecastType]} Forecast, ${ECostFormulaParamTypeLabel[selectedCostFormulaType]} Cost`;
};

export const getPricePerUnitLabel = (state: IStoreState): string => {
  const { selectedUnitType } = state.dealEvaluation;
  return selectedUnitType === EEvaluationUnit.TON ? labels.currency.dollarsPerTon : labels.currency.centsPerPound;
};
